(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markClone(el) {
      el.setAttribute('aria-hidden', 'true');
      el.removeAttribute('data-shopify-editor-block');
      el.querySelectorAll('a, button').forEach(function (n) {
        n.setAttribute('tabindex', '-1');
      });
    }

    function init(root) {
      var marquee = root.querySelector('[data-crm-marquee]');
      if (!marquee || marquee.dataset.crmReady) return;

      var track = marquee.querySelector('[data-crm-track]');
      var group = marquee.querySelector('[data-crm-group]');
      if (!track || !group || !group.children.length) return;

      // Theme editor / reduced motion: static, swipeable row (no clones)
      if ((window.Shopify && window.Shopify.designMode) || reduceMotion) {
        marquee.classList.add('crm-static');
        return;
      }

      marquee.dataset.crmReady = 'true';

      var originals = Array.prototype.slice.call(group.children);
      var target = Math.max(window.innerWidth, window.screen ? window.screen.width : 0);
      var repeats = 1;

      // With few reviews, repeat the set until one group is wider than the screen
      while (group.getBoundingClientRect().width < target && repeats < 12) {
        originals.forEach(function (card) {
          var c = card.cloneNode(true);
          markClone(c);
          group.appendChild(c);
        });
        repeats++;
      }

      // Second identical group makes the -50% loop seamless
      var groupClone = group.cloneNode(true);
      groupClone.removeAttribute('data-crm-group');
      markClone(groupClone);
      track.appendChild(groupClone);

      // Keep scroll speed consistent no matter how many times the set repeats
      var base = parseFloat(root.getAttribute('data-speed')) || 35;
      marquee.style.setProperty('--crm-duration', base * repeats + 's');
      marquee.classList.add('crm-ready');
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-crm]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
